import { render, staticRenderFns } from "./CompetitionArgue.vue?vue&type=template&id=2709760c&scoped=true"
import script from "./CompetitionArgue.vue?vue&type=script&lang=js"
export * from "./CompetitionArgue.vue?vue&type=script&lang=js"
import style0 from "./CompetitionArgue.vue?vue&type=style&index=0&id=2709760c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2709760c",
  null
  
)

export default component.exports